import { ISale, ISaleData } from "@/entities";
import { ISaleRepository } from "@/repositories";
import { ISaleService } from "./sales.types";

export class SaleService implements ISaleService {
    constructor(private repository: ISaleRepository) {}

    async getSaleById(id: string): Promise<ISale | undefined> {
        return await this.repository.get(id);
    }

    async createSale(userData: ISaleData): Promise<ISale> {
        return await this.repository.create(userData);
    }

    async syncSale(userData: ISaleData): Promise<ISale> {
        let user = await this.getSaleById(userData.id as string);
        console.log("syncSale: ", userData, user);
        if (user) {
            let hasChange = false;
            if (userData.firstname != null || userData.firstname != undefined) {
                if (userData.firstname != user.firstname) {
                    user = await this.updateSale(userData);
                    hasChange = true;
                }
            }
            if (userData.firstname != null || userData.firstname != undefined) {
                if (userData.lastname != user.lastname) {
                    user = await this.updateSale(userData);
                    hasChange = true;
                }
            }
            if (userData.firstname != null || userData.firstname != undefined) {
                if (userData.branch != user.branch) {
                    user = await this.updateSale(userData);
                    hasChange = true;
                }
            }
            if (userData.firstname != null || userData.firstname != undefined) {
                if (userData.username != user.username) {
                    user = await this.updateSale(userData);
                    hasChange = true;
                }
            }
            
            if(hasChange){
                user = await this.getSaleById(userData.id as string);
                if (user) {
                    return user;
                }
            }else{   
                return user;
            }
        }

        return await this.createSale(userData);
    }

    async updateSale(userData: ISaleData): Promise<ISale> {
        return await this.repository.update(userData);
    }
}
